var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-fechas"},[_c('buttons',{attrs:{"model_name":_vm.model_name}}),_c('fechas',{attrs:{"model_name":_vm.model_name}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }